<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/'+props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{ 'v-breadcrumbs__item v-breadcrumbs__item--disabled': props.item.disabled }"
                >{{props.item.text}}</router-link>
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{responseError}}</span>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="name"
                  label="Region Name"
                  v-model="region.name"
                  type="text"
                  :rules="rules.nameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-select
                  :items="currencyList"
                  label="Choose Currency ..."
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  v-model="region.currencyId"
                  :rules="rules.currencyRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="description"
                  label="Description"
                  v-model="region.description"
                  type="text"
                  :rules="rules.descriptionRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="region.id">
                <v-text-field label="Created Date" v-model="createdDate" type="text" readonly></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="region.id">
                <v-text-field label="Created By" v-model="region.createdBy" type="text" readonly></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="region.id">
                <v-text-field label="Updated Date" v-model="updatedDate" type="text" readonly></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="region.id">
                <v-text-field label="Updated By" v-model="region.updatedBy" type="text" readonly></v-text-field>
              </v-flex>
              <v-flex sm12 v-if="region.id">
                <v-switch
                  :label="`Status is ${statusFlag?'Active': 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :readonly="!valid"
                    type="submit"
                    :disabled="btnDisabled"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
              <v-flex v-if="region.id">
                <div>
                  <v-layout row wrap>
                    <v-btn color="success" @click="showProducts()">
                      Add Regional Product
                      <v-icon right>add</v-icon>
                    </v-btn>
                  </v-layout>
                </div>
                <v-flex xs12>
                  <v-card>
                    <v-layout row wrap class="pa-3">
                      <v-flex sm4>
                        <v-text-field
                          name="code"
                          label="Product Code"
                          type="text"
                          class="mr-1"
                          v-model="regionDetailQueryParams.productCode"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-text-field
                          name="name"
                          label="Product Name"
                          type="text"
                          class="mr-1"
                          v-model="regionDetailQueryParams.productName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex sm4>
                        <v-btn outline color="primary" @click="detailSearch">
                          Search
                          <v-icon right>search</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex xs12 class="mt-1">
                  <v-card>
                    <v-data-table
                      :must-sort="true"
                      :headers="detailHeaders"
                      :items="regionDetailList"
                      class="elevation-1"
                      :loading="detailListLoading"
                      :total-items="detailTotalRows"
                      :rows-per-page-items="detailRowsPerPageItems"
                      :pagination.sync="detailPagination"
                    >
                      <template slot="items" slot-scope="props">
                        <td>{{ props.item.productCode }}</td>
                        <td>{{ props.item.productName }}</td>
                        <td>{{ props.item.factorUnitName }}</td>
                        <td><v-icon v-if="props.item.basicPriceflag" medium color="green">spellcheck</v-icon>
                        <v-icon v-else medium color="red">format_italic</v-icon></td>
                        <td>{{ props.item.unitCost }}</td>
                        <td>{{ props.item.unitCostPercentage }}</td>
                        <td>{{ props.item.sellingPrice }}</td>
                        <td>{{ props.item.sellingPricePercentage }}</td>
                        <td>{{ props.item.wholeSaleSellingPrice }}</td>
                        <td>{{ props.item.wholeSaleSellingPricePercentage }}</td>
                        <td>
                          <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-btn icon @click="removePriceModelDetail(props.item)">
                            <v-icon>cancel</v-icon>
                          </v-btn>
                        </td>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="setProduct(props.item.code), showProductListDialog = !showProductListDialog"
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">{{ props.item.productGroup.name }}</td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Regional detail dialog -->
    <v-dialog v-model="showDetailListDialog" scrollable max-width="1000px" persistent>
      <v-form v-model="productValid">
        <v-card>
          <v-card-title>
            <v-layout wrap>
              <v-flex sm12 v-if="detailResponseError">
                <span class="red--text">* {{detailResponseError}}</span>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  name="regionName"
                  label="Region Name"
                  type="text"
                  class="mr-1"
                  v-model="region.name"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-flex row wrap class="pa-3">
                  <v-layout row wrap class="light--text">
                    <v-flex xs1>Code</v-flex>
                    <v-flex xs1>Product</v-flex>
                    <v-flex xs1>Unit</v-flex>
                    <v-flex xs1>Basic Price</v-flex>
                    <v-flex xs1>Unit Cost</v-flex>
                    <v-flex xs1>Unit Cost(%)</v-flex>
                    <v-flex xs2>Selling Price</v-flex>
                    <v-flex xs1>Selling Price(%)</v-flex>
                    <v-flex xs2>WholeSale Selling Price</v-flex>
                    <v-flex xs1>WholeSale Selling Price(%)</v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        placeholder="Product Code"
                        v-model="regionalProduct.productCode"
                        :rules="rules.codeRules"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="regionalProduct.productName"
                        :loading="showAutocompleteLoading"
                        :readonly="true"
                        :rules="rules.nameRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-autocomplete
                        v-model="regionalProduct.factorUnitName"
                        :loading="showAutocompleteLoading"
                        :hide-no-data="true"
                        :items="regionalProduct.productUnits"
                        color="blue-grey lighten-2"
                        item-value="factorUnitName"
                        item-text="factorUnitName"
                        @change="changeProductUnit(regionalProduct.factorUnitName)"
                        menu-props="auto"
                        label="Select"
                        :rules="rules.unitRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-checkbox v-model="regionalProduct.basicPriceflag" readonly></v-checkbox>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="regionalProduct.unitCost"
                        min="0"
                        :rules="rules.unitCostRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="regionalProduct.unitCostPercentage"
                        min="0"
                        :rules="rules.unitCostPercentageRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 pr-2>
                      <v-text-field
                        v-model="regionalProduct.sellingPrice"
                        min="0"
                        :rules="rules.sellingPriceRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="regionalProduct.sellingPricePercentage"
                        min="0"
                        :rules="rules.sellingPricePercentageRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 pr-2>
                      <v-text-field
                        v-model="regionalProduct.wholeSaleSellingPrice"
                        min="0"
                        :rules="rules.sellingPriceRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="regionalProduct.wholeSaleSellingPricePercentage"
                        min="0"
                        :rules="rules.sellingPricePercentageRules"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12>
                    <div class="text-xs-center">
                      <v-btn color="error" @click="cancel">
                        Cancel
                        <v-icon right>clear</v-icon>
                      </v-btn>
                      <v-btn color="primary" :loading="saveDetailLoading" :disabled="!productValid" @click.stop="saveDetail">
                        Save
                        <v-icon right>save</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-flex>
              </v-card>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog
      v-model="confirmBox"
      max-width="500px"
      @keydown.enter="deleteDetail()"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>Are you sure to delete this Regional Product({{ deleteRegionalProduct.productCode }})?</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="confirmBox=false">Cancel</v-btn>
          <v-btn color="success" large outline @click="deleteDetail()">Proceed</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { commonService } from "../../services/common-service";
import { RegionRules } from "../../helpers/validation-rules";
import { Region, RegionalProduct } from "../../models/model";
import { productService } from "../../services/product-service";
import { regionService } from "../../services/region-service";
import { currencyService } from "../../services/currency-service";

export default {
  name: "RegionDetail",
  components: { VSwitch },
  data: () => ({
    valid: true,
    productValid: true,
    breadcrumbs: [
      {
        text: "Region",
        disabled: false,
        to: "regions"
      },
      {
        text: "Regional Product",
        disabled: true
      }
    ],
    currencyList: [],
    productList: [],
    productUnitList: [],
    region: new Region(),
    oldregion: new Region(),
    regionalProduct: new RegionalProduct(),
    rules: new RegionRules(),
    deleteRegionalProduct: new RegionalProduct(),
    updatedDate: "",
    createdDate: "",
    unitCost: 0,
    statusFlag: true,
    saveLoading: false,
    showAutocompleteLoading: false,
    btnDisabled: false,
    regionDetailList: [],
    responseError: "",
    confirmBox: false,
    saveDetailLoading: false,
    detailResponseError: "",
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" }
    ],
    detailHeaders: [
      { text: "Code", value: "productCode" },
      { text: "Product", value: "productName" },
      { text: "Unit", value: "factorUnitName", sortable: false },
      { text: "Basic Price", value: "basicPriceflag", sortable: false },
      { text: "Unit Cost", value: "unitCost" },
      { text: "Unit Cost(%)", value: "unitCostPercentage" },
      { text: "Selling Price", value: "sellingPrice" },
      { text: "Selling Price(%)", value: "sellingPricePercentage" },
      { text: "WholeSale Selling Price", value: "wholeSaleSellingPrice", sortable: false },
      { text: "WholeSale Selling Price(%)", value: "wholeSaleSellingPricePercentage", sortable: false },
      { text: "Action", value: "", sortable: false }
    ],

    rowsPerPageItems: [10, 50, 100],
    detailRowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0
    },
    detailPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "product.code",
      totalItems: 0
    },
    totalRows: 0,
    detailTotalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: ""
    },
    regionDetailQueryParams: {
      productName: "",
      productCode: "",
      regionId: ""
    },
    search: null,
    code: "",
    showListLoading: false,
    detailListLoading: false,
    selectedIndex: 0,
    showDetailListDialog: false
  }),

  created() {
    //this.addRegionalProductDetail();
    this.getCurrencyLists();
    const id = this.$route.params.id;
    if (id != "new") {
      this.getRegionDetail(id);
      this.getProductList();
      this.getdetailProduct(id);
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true
    },
    detailPagination: {
      handler() {
        this.getdetailProduct(this.$route.params.id);
      }
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },

    goBack() {
      this.$router.push("/regions");
    },
    getCurrencyLists() {
      currencyService
        .getAllCurrency()
        .then(res => {
          if (res.data) {
            this.currencyList = res.data;
            console.log(this.currencyList);
            console.log(res.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    showProducts() {
      // Clean query params
      this.queryParams.productCode = "";
      this.queryParams.productName = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },

    setProduct(code) {
      let product = commonService.search("code", code, this.productList);
      this.regionalProduct = new RegionalProduct();
      this.regionalProduct.regionId = this.region.id;
      this.regionalProduct.productId = product.id;
      this.regionalProduct.productCode = product.code;
      this.regionalProduct.productName = product.name;
      this.regionalProduct.productUnits = product.productUnits;
      this.regionalProduct.factorUnitName = "";
      this.detailResponseError = "";
      let productUnit = commonService.search("basicPriceflag", true, this.regionalProduct.productUnits);
      if(productUnit){
        this.regionalProduct.factorUnitName = productUnit.factorUnitName;
        this.regionalProduct.basicPriceflag = productUnit.basicPriceflag;
        this.regionalProduct.productUnitId = productUnit.id;
      }
      this.showDetailListDialog = !this.showDetailListDialog;
    },
    changeProductUnit(factorUnitName){
      let productUnit = commonService.search("factorUnitName", factorUnitName, this.regionalProduct.productUnits);
      this.regionalProduct.basicPriceflag = productUnit.basicPriceflag;
      this.regionalProduct.productUnitId = productUnit.id;
    },

    removePriceModelDetail(regionalProduct) {
      this.deleteRegionalProduct = new RegionalProduct();
      this.deleteRegionalProduct = regionalProduct;
      this.deleteRegionalProduct.regionId = this.region.id;
      this.confirmBox = true;
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.region.id) {
        this.region = new Region();
        this.statusFlag = true;
      } else {
        this.region = Object.assign({}, this.oldregion);
        this.statusFlag = this.region.status == "ACTIVE" ? true : false;
      }
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.region.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        regionService
          .saveRegion(this.region)
          .then(res => {
            if (res) {
              this.goBack();
            }
          })
          .catch(err => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    getRegionDetail(id) {
      regionService
        .getRegion(id)
        .then(res => {
          this.region = res.data;
          console.log(this.region);
          this.createdDate = commonService.formatDate(
            new Date(this.region.createdDateInMilliSeconds)
              .toISOString()
              .substring(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.region.updatedDateInMilliSeconds)
              .toISOString()
              .substring(0, 10),
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldregion = JSON.parse(JSON.stringify(this.region));
          this.statusFlag = this.region.status == "ACTIVE" ? true : false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    detailSearch() {
      this.regionDetailQueryParams.page = this.detailPagination.page;
      this.regionDetailQueryParams.size = this.detailPagination.rowsPerPage;
      this.getdetailProduct(this.region.id);
    },
    getdetailProduct(id) {
      this.detailListLoading = true;
      let order = this.detailPagination.descending ? "desc" : "asc";
      this.regionDetailQueryParams.regionId = id;
      regionService
        .getRegionDetailProduct(
          this.regionDetailQueryParams,
          this.detailPagination.page,
          this.detailPagination.rowsPerPage,
          this.detailPagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.regionDetailList = res.data.regionalProductDTOList;
            this.detailTotalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.detailListLoading = false;
        });
    },
    cancel() {
      this.showDetailListDialog = !this.showDetailListDialog;
      if (!this.regionalProduct.id) {
        this.showProductListDialog = !this.showProductListDialog;
      }
      this.getdetailProduct(this.region.id);
    },
    saveDetail() {
      this.saveDetailLoading = true;
      regionService
        .saveRegionDetail(this.regionalProduct)
        .then(res => {
          if (res) {
            this.showDetailListDialog = !this.showDetailListDialog;
            if (!this.regionalProduct.id) {
              this.showProductListDialog = !this.showProductListDialog;
            }
            this.getdetailProduct(this.region.id);
          }
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.detailResponseError = err.response.data.message;
          }
          this.saveDetailLoading = false;
        })
        .finally(() => {
          this.saveDetailLoading = false;
        });
    },
    deleteDetail() {
      regionService
        .deleteRegionDetail(this.deleteRegionalProduct)
        .then(res => {
          if (res) {
            this.confirmBox = false;
            this.getdetailProduct(this.region.id);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    onEdit(regionalProduct) {
      this.detailResponseError = "";
      this.regionalProduct = new RegionalProduct();
      this.regionalProduct = regionalProduct;
      this.regionalProduct.regionId = this.region.id;
      this.showDetailListDialog = !this.showDetailListDialog;
    }
  }
};
</script>
